import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class EditUserInfoService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web de actualizar información principal del usuario
   * Autor: Diego Diaz
   * @param accountId identificador del usuario
   * @param mainEmail email princpal
   * @return Mensaje de confirmación de la actualización
   */
  updateUserMainInfo(accountId, mainEmail) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_LOGIN_UPDATE_USER_INFORMATION, { "billingAccountId": accountId, "email": mainEmail });
  }

   /**
   * Description: Método que llama el servicio web que retorna la información de registro civil
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  getInfoByDocument(documentType, documentId){
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_GET_USER_INFO_FROM_STATE_AGENCY_BY_DOCUMENT, { "identificationType": documentType, "identificationNumber": documentId });
  }
}
